$(document).ready(function () {
            // Hover in
            $('.x-menu--level-1--link').hover(
                function () {
                    // Change data-x-menu--open to true
                    $(this).attr('data-x-menu--open', 'true');

                    // Change aria-hidden to false and remove style="display: none;"
                    $(this).find('.x-menu--level-2--container')
                        .attr('aria-hidden', 'false')
                        .removeAttr('style');
                },
                // Hover out
                function () {
                    // Change data-x-menu--open to false
                    $(this).attr('data-x-menu--open', 'false');

                    // Change aria-hidden to true and add style="display: none;"
                    $(this).find('.x-menu--level-2--container')
                        .attr('aria-hidden', 'true')
                        .css('display', 'none');
                }
            );
        });

document.addEventListener("DOMContentLoaded", function() {
    const np_ll_laker = document.querySelector('.header--bottom-row > .header--menu > .x-menu > .x-menu--level-1--container [data-link-id="nail-polish--long-lasting-polish-lacquer"]');
    const np_laker = document.querySelector('.header--bottom-row > .header--menu > .x-menu > .x-menu--level-1--container [data-link-id="nail-polish--nail-polish-lacquer"]');

    if (np_ll_laker && np_laker) {
        np_laker.innerHTML += np_ll_laker.innerHTML;
        np_ll_laker.remove();
    }
});
